import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(numFichaVta, obsLafit) {
  const data = {
    observacion: obsLafit,
  };

  console.log(data); // se cambio a get el servicio

  const config = {
    params:{
      observacion: obsLafit,

    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  return customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVta}/enviar-lafit`,config);
}



// WEBPACK FOOTER //
// ./src/utils/notifyLafit.js